import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';
import AssociateConcernManagement from '../pages/factsheet/AssociateConcernManagement';
import AssociateConcernCompanyBackgroundForm from '../forms/AssociateConcernCompanyBackgroundForm';
import AssociateConcernDebt from '../pages/factsheet/AssociateConcernDebt';
import AssociateConcernFinancials from '../pages/factsheet/AssociateConcernFinancials';

const AssociateConcernLayout = (props) => {
  const associateConcern = props.associateConcerns.find((entry) => (entry.id === parseInt(props.match.params.cac_id, 10)));
  return (
    <div className="ec-content-box">
      <h2>Associate Concern - {associateConcern.name}</h2>
      <Switch>
        <Route path={`${props.match.path}/management`} render={(routeProps) => (<AssociateConcernManagement {...routeProps} managementPersons={associateConcern.management_persons} />)} />
        <Route
          path={`${props.match.path}/company`}
          render={(routeProps) => (
            <AssociateConcernCompanyBackgroundForm {...routeProps} cacCompanyBackground={associateConcern.company_background} cac_id={props.match.params.cac_id} customer_id={props.match.params.id} />
          )}
        />
        <Route
          path={`${props.match.path}/debt`}
          render={(routeProps) => (
            <AssociateConcernDebt {...routeProps} debtPosition={associateConcern.debt_position} cac_id={props.match.params.cac_id} customer_id={props.match.params.id} />
          )}
        />
        <Route
          path={`${props.match.path}/financials`}
          render={(routeProps) => (
            <AssociateConcernFinancials {...routeProps} financials={associateConcern.brief_financials} cac_id={props.match.params.cac_id} customer_id={props.match.params.id} />
          )}
        />
      </Switch>
    </div>
  );
};

AssociateConcernLayout.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
      cac_id: PropTypes.string.isRequired,
    }),
  }).isRequired,
  associateConcerns: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    management_persons: PropTypes.array,
  })).isRequired,
};
export default AssociateConcernLayout;



// WEBPACK FOOTER //
// ./src/layouts/AssociateConcernLayout.jsx